var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitBusinessData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card setting-card" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v(_vm._s(_vm.$t("profile.business_status.business_status"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-6 mb-4" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(_vm.$tc("profile.business_status.business_status"))
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-select", {
                  class: { error: _vm.$v.formData.status.$error },
                  attrs: {
                    options: _vm.businessStatuses,
                    searchable: true,
                    "show-labels": false,
                    "allow-empty": false,
                    placeholder: _vm.$t(
                      "profile.business_status.select_business_status"
                    ),
                  },
                  model: {
                    value: _vm.formData.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "status", $$v)
                    },
                    expression: "formData.status",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.status.$error
                  ? _c("div", [
                      !_vm.$v.formData.status.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.$tc("validation.required"))),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-4" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(_vm.$tc("profile.business_status.business_nature"))
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-select", {
                  class: { error: _vm.$v.formData.nature.$error },
                  attrs: {
                    options: _vm.businessNature,
                    searchable: true,
                    "show-labels": false,
                    "allow-empty": false,
                    placeholder: _vm.$t(
                      "profile.business_status.select_business_nature"
                    ),
                  },
                  model: {
                    value: _vm.formData.nature,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "nature", $$v)
                    },
                    expression: "formData.nature",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.nature.$error
                  ? _c("div", [
                      !_vm.$v.formData.nature.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.$tc("validation.required"))),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mb-4" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc("profile.business_status.annual_sales_turnover")
                    )
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: { type: "numeric" },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.annual_sales_turnover.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.annual_sales_turnover,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "annual_sales_turnover", $$v)
                    },
                    expression: "formData.annual_sales_turnover",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.annual_sales_turnover.$error
                  ? _c("div", [
                      !_vm.$v.formData.annual_sales_turnover.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.$tc("validation.required"))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.annual_sales_turnover.numeric
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.$tc("validation.numbers_only"))),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mb-4" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "profile.business_status.num_employee_including_contract"
                      )
                    )
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-input", {
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.total_employees.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.total_employees,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "total_employees", $$v)
                    },
                    expression: "formData.total_employees",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.total_employees.$error
                  ? _c("div", [
                      !_vm.$v.formData.total_employees.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.$tc("validation.required"))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.total_employees.numeric
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.$tc("validation.numbers_only"))),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("p", { staticClass: "text-danger" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$tc("profile.business_status.contact_note"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    attrs: {
                      loading: _vm.isLoading,
                      disabled: _vm.isLoading,
                      icon: "save",
                      color: "theme",
                      type: "submit",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$tc("profile.business_status.save")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }